// extracted by mini-css-extract-plugin
export default {"container":"ButtonSelector_container__n2R1D","btn":"ButtonSelector_btn__SmnIc"};